import { axiosInstance } from "../../config/api";

const g = (u, c) => axiosInstance.get(u, c).then((r) => r.data);
const p = (u, b, c) => axiosInstance.post(u, b, c).then((r) => r.data);

export const lpApi = {
  designer: () => g("/lp/designer-config"),
  saveDesigner: (body) => axiosInstance.put("/lp/designer-config", body).then((r) => r.data),
  designerModels: (provider, api_key) => p("/lp/designer-models", { provider, api_key }, { timeout: 60000 }),
  designerTest: (provider, model, api_key) => p("/lp/designer-test", { provider, model, api_key }, { timeout: 120000 }),
  models: (refresh) => g("/lp/models", { params: refresh ? { refresh: true } : {}, timeout: 60000 }),
  projects: () => g("/lp/projects"),
  create: (body) => p("/lp/projects", body),
  get: (id) => g(`/lp/projects/${id}`),
  patch: (id, body) => axiosInstance.patch(`/lp/projects/${id}`, body).then((r) => r.data),
  remove: (id) => axiosInstance.delete(`/lp/projects/${id}`).then((r) => r.data),
  saveHtml: (id, html, note, source) => axiosInstance.put(`/lp/projects/${id}/html`, { html, note, source }).then((r) => r.data),
  validate: (html) => p("/lp/validate", { html }),
  generate: (id, body) => p(`/lp/projects/${id}/generate`, body),
  section: (id, body) => p(`/lp/projects/${id}/section`, body),
  job: (jid) => g(`/lp/jobs/${jid}`),
  cancelJob: (jid) => p(`/lp/jobs/${jid}/cancel`),
  undo: (id) => p(`/lp/projects/${id}/undo`),
  redo: (id) => p(`/lp/projects/${id}/redo`),
  versions: (id) => g(`/lp/projects/${id}/versions`),
  restoreVersion: (id, v) => p(`/lp/projects/${id}/versions/${v}/restore`),
  slugCheck: (slug, project_id) => g("/lp/slug-check", { params: { slug, project_id } }),
  setSlug: (id, slug, redirect_old) => p(`/lp/projects/${id}/slug`, { slug, redirect_old }),
  slugSuggest: (id, model_id) => p(`/lp/projects/${id}/slug-suggest`, { model_id }, { timeout: 90000 }),
  removeRedirect: (id, slug) => axiosInstance.delete(`/lp/projects/${id}/redirects/${slug}`).then((r) => r.data),
  publish: (id) => p(`/lp/projects/${id}/publish`),
  unpublish: (id) => p(`/lp/projects/${id}/unpublish`),
  addAsset: (id, a) => p(`/lp/projects/${id}/assets`, a),
  removeAsset: (id, fid) => axiosInstance.delete(`/lp/projects/${id}/assets/${fid}`).then((r) => r.data),
  templates: () => g("/lp/templates"),
  saveTemplate: (body) => p("/lp/templates", body),
  deleteTemplate: (tid) => axiosInstance.delete(`/lp/templates/${tid}`).then((r) => r.data),
  exportZip: (id) => axiosInstance.get(`/lp/projects/${id}/export`, { responseType: "blob", timeout: 120000 }).then((r) => r.data),
  submissions: (id) => g(`/lp/projects/${id}/submissions`),
  submissionsCsv: (id) => axiosInstance.get(`/lp/projects/${id}/submissions.csv`, { responseType: "blob" }).then((r) => r.data),
  setSubmission: (sid, status) => axiosInstance.patch(`/lp/submissions/${sid}`, { status }).then((r) => r.data),
  deleteSubmission: (sid) => axiosInstance.delete(`/lp/submissions/${sid}`).then((r) => r.data),
};

export const publicUrl = (slug) => `${window.location.origin}/${slug}`;

export const downloadBlob = (blob, name) => {
  const u = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = u; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(u), 2000);
};

export const errMsg = (e, fb = "Ralat") => e?.response?.data?.detail || e?.message || fb;
